import React from 'react';
import styles from './InputField.scss';
import lodash from 'lodash';
import { Conditional } from 'common/components/layout/index';

/**
 * @typedef {object} InputClassesOverrides
 * @property {string} inputWrapper
 */

/**
 * @typedef {object} InputParams
 * @property {string} label
 * @property {string} htmlFor
 * @property {boolean} required
 * @property {string} helperText
 * @property {InputClassesOverrides} customClasses
 * @property {*} children
 */

/**
 * A convienient wrapper for input fields.
 *
 * @param {InputParams} options
 */
export default function InputField({ label, htmlFor, required, helperText, customClasses, children }) {
    const customInputWrapperClass = lodash.get(customClasses, 'inputWrapper', '');

    return (
        <div className={`${customInputWrapperClass ? customInputWrapperClass : styles.inputFieldWrapper}`} data-cy="SelectionModal-InputField">
            <label className={styles.label} htmlFor={htmlFor} data-cy="SelectionModal-label">
                {label}
            </label>
            <RequiredLabel required={required} data-cy="SelectionModal-children" />
            {children}
            <HelperText helperText={helperText} />
        </div>
    );
}

export const RequiredLabel = ({ required }) => (
    <Conditional condition={required}>
        <span className={styles.required}>*Required</span>
    </Conditional>
);

export const HelperText = ({ helperText }) => (
    <Conditional condition={helperText}>
        <div className={styles.helperText} data-cy="SelectionModal-HelperText">
            <p data-cy="SelectionModal-helperText">{helperText}</p>
        </div>
    </Conditional>
);
